import { createSlice } from "@reduxjs/toolkit"

export const setReducer = createSlice({
    name: "setAgeNumber",
    initialState: {
        value: null,
    },
    reducers: {
        setAgeNumber: (state, action) => {
            state.value = action.payload
        },
    },
})

export const { setAgeNumber } = setReducer.actions

export default setReducer.reducer
